// Google Analytics 4 (GA4) utility functions

// Get GA4 tracking ID from environment variables
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// Track page views
export const trackPageView = (path, title) => {
  if (typeof window !== 'undefined' && window.gtag && GA_TRACKING_ID) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: title,
      page_location: window.location.href,
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag && GA_TRACKING_ID) {
    window.gtag('event', eventName, parameters);
  }
};

// Track app download clicks
export const trackAppDownload = (platform) => {
  trackEvent('app_download_click', {
    platform: platform,
    event_category: 'download',
    event_label: platform,
  });
};

// Track external link clicks
export const trackExternalLink = (url, linkText) => {
  trackEvent('click', {
    event_category: 'external_link',
    event_label: linkText,
    value: url,
  });
};

// Export GA tracking ID for use in other files
export { GA_TRACKING_ID };
